import React from 'react';
import './blog-page.css'; // Import the CSS file

const BlogPage = () => {
  return (
    <div className="section-padding-bottom-0 layout layout--onecol-section layout--onecol-section--100 container">
      <div className="layout__region layout__region--content">
        <div className="views-element-container block block-views block-views-blockrelated-news-block-2">
          <div className="block__content">
            <div className="view view-related-news view-id-related_news view-display-id-block_2 js-view-dom-id-138687804fc60370823a3635dfa235e37ca14c6f1fae68206d5ad164e958d93b">
              <div className="view-content">
                <div className="section-blue-half">
                  <div className="grid">
                    <h2 className="pb">Latest news</h2>
                  </div>
                  <div className="grid lg-3 md-3">
                    <div className="views-row"> 
                      <div className="span">
                        <div className="card">
                          <div className="card-img">
                            <img
                              alt="NYC steering committee 2024"
                              src="caic-nyc.jpg"
                              width="370"
                              height="197"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                          <div className="card-content">
                            <span className="ico-label ico-label--read">
                              <div
                                content="3"
                                className="field field--name-field-article-reading-time field--type-integer field--label-hidden field__item"
                              >
                                3&nbsp;min read
                              </div>
                            </span>
                            <h3>
                              <a href="https://thecommonwealth.org/news/commonwealth-artificial-intelligence-consortium-caic-bridges-ai-divide" target="_blank" rel="noopener noreferrer">
                                <span>
                                Commonwealth Artificial Intelligence Consortium (CAIC) bridges the AI divide                                </span>
                              </a>
                            </h3>
                            <span className="text-label" aria-hidden="true">
                              Read news
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="views-row"> 
                      <div className="span">
                        <div className="card">
                          <div className="card-img">
                            <img
                              alt="speakers come together at marlborough house"
                              src="sas.jpg"
                              width="370"
                              height="197"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                          <div className="card-content">
                            <span className="ico-label ico-label--read">
                              <div
                                content="3"
                                className="field field--name-field-article-reading-time field--type-integer field--label-hidden field__item"
                              >
                                3&nbsp;min read
                              </div>
                            </span>
                            <h3>
                              <a href="https://thecommonwealth.org/news/commonwealth-secretariat-and-sas-join-forces-secure-equitable-digital-future-young-people" target="_blank" rel="noopener noreferrer">
                                <span>
                                The Commonwealth Secretariat and SAS join forces to secure an equitable digital future for young people
                                </span>
                              </a>
                            </h3>
                            <span className="text-label" aria-hidden="true">
                              Read news
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="views-row">
                      <div className="span">
                        <div className="card">
                          <div className="card-img">
                            <img
                              alt="Gambia AI event"
                              src="gambia-training.jpg"
                              width="370"
                              height="197"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                          <div className="card-content">
                            <span className="ico-label ico-label--read">
                              <div
                                content="3"
                                className="field field--name-field-article-reading-time field--type-integer field--label-hidden field__item"
                              >
                                3&nbsp;min read
                              </div>
                            </span>
                            <h3>
                              <a href="https://thecommonwealth.org/news/commonwealth-empowers-educators-gambia-artificial-intelligence-training" target="_blank" rel="noopener noreferrer">
                                <span>
                                Commonwealth empowers educators in The Gambia with artificial intelligence training
                                </span>
                              </a>
                            </h3>
                            <span className="text-label" aria-hidden="true">
                              Read news
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="views-row">
                      <div className="span">
                        <div className="card">
                          <div className="card-img">
                            <img
                              alt="StrategusAI launch event"
                              src="strategusai.png"
                              width="370"
                              height="197"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                          <div className="card-content">
                            <span className="ico-label ico-label--read">
                              <div
                                content="2"
                                className="field field--name-field-article-reading-time field--type-integer field--label-hidden field__item"
                              >
                                2&nbsp;min read
                              </div>
                            </span>
                            <h3>
                              <a href="https://thecommonwealth.org/news/commonwealth-secretariat-and-intel-launches-strategusai-ai-driven-policy-toolkit-commonwealth" target="_blank" rel="noopener noreferrer">
                                <span>
                                The Commonwealth Secretariat and Intel launches StrategusAI
                                </span>
                              </a>
                            </h3>
                            <span className="text-label" aria-hidden="true">
                              Read news
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="views-row">
                      <div className="span">
                        <div className="card">
                          <div className="card-img">
                            <img
                              alt="Youth VR"
                              src="vrimage.png"
                              width="370"
                              height="197"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                          <div className="card-content">
                            <span className="ico-label ico-label--read">
                              <div
                                content="1"
                                className="field field--name-field-article-reading-time field--type-integer field--label-hidden field__item"
                              >
                                1&nbsp;min read
                              </div>
                            </span>
                            <h3>
                              <a href="https://thecommonwealth.org/news/pivotal-moments-50-years-commonwealth-youth-programme-captured-virtual-exhibition" target="_blank" rel="noopener noreferrer">
                                <span>
                                Commonwealth Youth Programme captured in a virtual exhibition
                                </span>
                              </a>
                            </h3>
                            <span className="text-label" aria-hidden="true">
                              Read news
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="views-row">
                      <div className="span">
                        <div className="card">
                          <div className="card-img">
                            <img
                              alt="OpenWeaver launch"
                              src="openweaver.png"
                              width="370"
                              height="197"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                          <div className="card-content">
                            <span className="ico-label ico-label--read">
                              <div
                                content="3"
                                className="field field--name-field-article-reading-time field--type-integer field--label-hidden field__item"
                              >
                                3&nbsp;min read
                              </div>
                            </span>
                            <h3>
                              <a href="https://thecommonwealth.org/news/we-must-leave-no-one-behind">
                                <span>
                                AI entrepreneurship Make-A-Thon: From digital consumer to digital creator with Open Weaver
                                </span>
                              </a>
                            </h3>
                            <span className="text-label" aria-hidden="true">
                              Read news
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="views-row">
                      <div className="span">
                        <div className="card">
                          <div className="card-img">
                            <img
                              alt="Sir Shridath Ramphal"
                              src="https://production-new-commonwealth-files.s3.eu-west-2.amazonaws.com/s3fs-public/styles/card/public/2024-08/sir-shridath-ramphal.png?VersionId=VNGoVOIQguSuwjrbyTmTC7ipH_vhooGv&itok=fq2ctAKZ"
                              width="370"
                              height="197"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                          <div className="card-content">
                            <span className="ico-label ico-label--read">
                              <div
                                content="2"
                                className="field field--name-field-article-reading-time field--type-integer field--label-hidden field__item"
                              >
                                2&nbsp;min read
                              </div>
                            </span>
                            <h3>
                              <a href="/news/statement-commonwealth-secretary-general-passing-sir-shridath-ramphal">
                                <span>
                                  Statement from the Commonwealth Secretary-General on the passing of Sir Shridath Ramphal
                                </span>
                              </a>
                            </h3>
                            <span className="text-label" aria-hidden="true">
                              Read news
                            </span>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-1 bg content-block--content-block block block-layout-builder block-inline-blockcontent-block custom-content-block">
          <div className="content-block--body clearfix">
            <p className="text-align-center">
              <a className="link-button" href="https://thecommonwealth.org/news">
                See all latest news of The Commonwealth
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;